import { apiClient } from './apiClient';

function resolveAfter(value, delay = 120) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(value), delay);
  });
}

export const CLIENT_PORTAL_PAGE_SIZE = 50;

async function getJson(url) {
  const response = await apiClient(url, {
    headers: { Accept: 'application/json' },
    credentials: 'include',
  });

  return response.json();
}

export async function fetchClientPortalPartners() {
  return await getJson('/api/client/partners');
}

export async function fetchClientPortalInvoices({ pageParam = 0 }) {
  return await getJson(`/api/client/invoices/?offset=${pageParam}&limit=${CLIENT_PORTAL_PAGE_SIZE}`);
}

export async function fetchClientPortalOpenInvoices() {
  return await getJson('/api/client/invoices/?filter=open');
}

export async function fetchClientPortalUnreconciled() {
  return await getJson('/api/client/unreconciled');
}

export async function fetchClientPortalOrders({ pageParam = 0 }) {
  return await getJson(`/api/client/orders/?offset=${pageParam}&limit=${CLIENT_PORTAL_PAGE_SIZE}`);
}

export async function fetchClientPortalDeliveries({ pageParam = 0 }) {
  return await getJson(`/api/client/deliveries/?offset=${pageParam}&limit=${CLIENT_PORTAL_PAGE_SIZE}`);
}
export async function fetchClientPortalDeliveriesOpen() {
  return await getJson(`/api/client/deliveries/?filter=open`);
}

export async function fetchClientPortalDeliveryIssues() {
  return await getJson('/api/client/deliveries/?filter=missing_docs');
}

export async function fetchClientPortalOrder({ queryKey }) {
  const [, orderName] = queryKey;

  return  await getJson(`/api/client/orders/${orderName}/`);
}

export async function fetchClientPortalDelivery({ queryKey }) {
  const [, deliveryName] = queryKey;

  return await getJson(`/api/client/deliveries/${deliveryName}/`);
}

export async function fetchClientPortalInvoice({ queryKey }) {
  const [, invoiceName] = queryKey;

  return await getJson(`/api/client/invoices/${invoiceName}/`);
}

export async function fetchClientPortalInvoicePayments(invoiceName) {
  return await getJson(`/api/client/invoices/${encodeURIComponent(invoiceName)}/payments/`);
}
